<template>
  <TaskCountsTable></TaskCountsTable>
</template>

<script>
import TaskCountsTable from '@/components/activist/TaskCountsTable'

export default {
  name: 'ActivistMetricsCountsTable',
  components: { TaskCountsTable },
}
</script>
